module.exports = {"title":"ShowTix4U POS Terminal","registrationCode":"Registration Code","terminal":"Terminal","existingTerminals":"Existing Terminals","label":"Label","id":"Terminal ID","edit":"Edit","makeDefault":"Make Default Terminal","removeDevice":"Remove terminal","cancel":"Cancel","update":"Update","tips":[{"title":"Tip","content":"<p><a href='http://equipment.showtix4u.com' target='_blank'>Shop for ShowTix4U POS Terminal</a></p>"},{"title":"Tip","content":"<p>Your POS Terminal Admin PIN is:</p><h3>07139</h3>"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Client/Stripe/locales/en.json
// module id = 1943
// module chunks = 0